/**
 * User: mphee
 * Date: 1/29/13
 * Time: 9:19 AM
 */

define(function (require) {
    'use strict';
    var Alert = require('common/views/Alert'),
        EasyDialog = require('easyDialog'),

        html_template = require('common/templates/notifications/LiveReminder.html'),
        template = _.template(html_template);

    return Backbone.View.extend({
        
        initialize: function () {
            if (this.options.notification) {
                // Came from notification.
                var notification = this.options.notification;
                
                this.scheduleId = notification.scheduleId;
                this.courseId = notification.courseId;
                this.notificationId = notification.id;
            } else if (this.options.liveclass) {
                // Came from live class
                
                this.scheduleId = this.options.liveclass.scheduleId;
                this.courseId = this.options.liveclass.courseId;
            }
        },
        
        onClose: function(event) {
            event.preventDefault();
            event.stopPropagation();

            $.easydialog.close('default');
        },
        
        render: function () {
            var data = this._prepareData();

            this.$el.html(template(data));
            
            return this;
        },

        show: function() {
            var me = this;

            me._confirmNotification();

            $.easydialog({
                content: $('#live-class-reminder'),
                closeOnEscape: false,
                onStart: function() {
                    me.$popup = $('#live-class-reminder');

                    me.$popup.find('.btn-close').on('click', function(event) {
                        me.onClose(event);
                    });
                },
                onCleanup: function() {
                	me._joinClass();
                	me.remove();
                }
            });
        },
        
        _confirmNotification: function() {
            if (this.notificationId) {
                $.ajax({
                    type: 'POST',
                    url: '/notifications/confirm/' + this.notificationId,
                    dataType: 'text',
                    async: false,
                    success: function() {
                        this.notificationId = null;
                    },
                    error: function(jqXHR, textStatus, errorThrown) {
                        // nothing better to do than nothing
                    }
                });
            }
        },
//TODO Look at when this is getting called
        _joinClass: function() {
            var me = this,
                success = false;

            $.ajax({
                type: 'POST',
                url: '/liveclasses/requestliveclasses/' + this.scheduleId + '/' + this.courseId,
                dataType: 'text',
                contentType: 'application/json',
                async: false,
                success: function(data, textStatus, jqXHR) {
                    Backbone.trigger('liveclass:joined', {scheduleId: me.scheduleId, courseId: me.courseId});
                    success = true;
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    new Alert({title: i18n.alert.titleError, text: i18n.liveReminder.errors.joinError, container: 2});
                }
            });

            return success;
        },

        _prepareData: function() {
            var data = {
                i18n: i18n,
                i18nPage: i18n.liveReminder
            };
            
            return data;
        }
    });
});



//////////////////
// WEBPACK FOOTER
// ./js/common/views/notifications/LiveReminder.js
// module id = 1064
// module chunks = 26 27 28